import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiPayments = () => {
 const { auth } = contextApp();

 const PaymentApi = axios.create({
  baseURL: urls.payment(),
  headers: { 'x-access-token': auth?.token }
 });

 const acceptanceToken = async comapany => (await PaymentApi.get('/acceptanceToken/' + comapany)).data;

 const getContracts = async e => (await PaymentApi.get(`/${e.docType}/${e.docNumber}`)).data;

 const getTransaction = async id => (await PaymentApi.get(`/transaction/${id}`)).data;

 const getPayments = async () => (await PaymentApi.get('/')).data;

 const alterPayment = async ({ id, data }) => (await PaymentApi.put('/' + id, data)).data;

 const createPayment = async project => (await PaymentApi.post('/', project)).data;

 return { getContracts, acceptanceToken, createPayment, getTransaction, getPayments, alterPayment };
};
